/**
 * ICON BUTTON
 * Bouton avec icône uniquement, avec variants CVA
 * Remplace les boutons icône inline répétés dans le projet
 */

import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

const iconButtonVariants = cva(
  'inline-flex items-center justify-center rounded-md transition-colors disabled:pointer-events-none disabled:opacity-50 shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-white border border-zinc-200 shadow-xs hover:bg-zinc-50',
        primary: 'bg-zinc-900 shadow-sm hover:bg-zinc-800',
        ghost: 'hover:bg-zinc-100',
        destructive:
          'bg-white border border-zinc-200 shadow-xs hover:bg-red-50 hover:border-red-200',
      },
      size: {
        sm: 'size-8',
        default: 'size-9',
        lg: 'size-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof iconButtonVariants> {
  icon: React.ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size, icon, ...props }, ref) => {
    return (
      <button className={cn(iconButtonVariants({ variant, size, className }))} ref={ref} {...props}>
        {icon}
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
